A deep link to the SEEK employer website where the hirer can manage their brands.

This field accepts browser tokens that include the `query:organizations` scope.
